<template>
	<div class="caseBox">

		<div class="max-caseBox">
			<div class="caseBox-banner">
				<div class="caseBox-banner-in">
					<div class="caseBox-banner-in-logo"></div>
				</div>
			</div>
			
			<div class="caseBox-nr">
				<div class="caseBox-nr-fenlei">
					<div class="caseBox-nr-fenlei-item" :class="[item.xz?'caseBox-nr-fenlei-item-xz':'']" v-for="(item,index) in caseFenlei" :key="index" @click="tapFenleiItem(index)">{{item.name}}</div>
				</div>
				<div class="caseBox-nr-left" v-show="dataShow">
					<div class="caseBox-nr-left-item" :class="[item.xz?'xz':'']" v-for="(item,index) in dataArr"
						:key="index" @click="tapItem(index)">
						<img :src="$store.state.website + item.image" style="width: 100%;" />
						<div class="caseBox-nr-left-item-tit">{{item.title}}</div>
					</div>
				</div>
				<div class="caseBox-nr-right" v-show="dataShow">
					<div class="caseBox-nr-right-tit">
						{{dataItem.title}}
					</div>
					<div class="caseBox-nr-right-img">
						<img :src="$store.state.website + dataItem.image" style="width:100%;" />
					</div>
			
					<div class="caseBox-nr-right-text" v-html="dataItem.text">
						<!-- {{dataItem.text}} -->
					</div>
				</div>
				<div style="clear:both"></div>
				<!-- 			<div class="caseBox-nr-fy">
					<div class="caseBox-nr-fy-item">上一页</div>
					<div class="caseBox-nr-fy-item">下一页</div>
				</div> -->
			</div>
			
			
			<PageBottom />
		</div>
		
		<div class="min-caseBox">
			
			<div class="min-caseBox-top">
				<!-- <div class="min-caseBox-top-icon"></div> -->
				成功案例
			</div>
			
			<div class="min-home-case-fenlei" ref="elememtFenlei">
				<div class="min-home-case-fenlei-item" :class="[item.xz?'min-home-case-fenlei-item-xz':'']"
					v-for="(item,index) in caseFenlei" :key="index" @click="tapFenleiItem(index)">{{item.name}}
				</div>
			</div>
			
			<div class="min-caseBox-box" :style="{height:minHeight}">
				<div class="min-caseBox-box-left" v-show="dataShow">
					<div class="min-caseBox-box-left-in">
						<div class="min-caseBox-box-left-in-item" :class="[item.xz?'min-caseBox-box-left-in-item-xz':'']" v-for="(item,index) in dataArr" :key='index' @click="tapItem(index)">
							<img :src="$store.state.website + item.image" width="100%" style="vertical-align:middle;">
						</div>
					</div>
				</div>
				<div class="min-caseBox-box-right" v-show="dataShow">
					<div class="min-caseBox-box-right-in">
						<div class="min-caseBox-box-right-in-tit">
							{{dataItem.title}}
						</div>
						<div class="min-caseBox-box-right-in-img">
							<img :src="$store.state.website + dataItem.image" style="width:100%;" />
						</div>
									
						<div class="min-caseBox-box-right-in-text" v-html="dataItem.text">
							<!-- {{dataItem.text}} -->
						</div>
					</div>
				</div>
			</div>
			
			
		</div>
		
		
	</div>
</template>

<script>
	import PageBottom from '@/components/PageBottom.vue'
	export default {
		name: 'Home',
		components: {
			PageBottom
		},
		data() {
			return {
				dataArr: [{
						id: 0,
						xz: true,
						img: require('../assets/anliimg.png'),
						tit: '1座椅护罩冲孔设备',
						text: '11自动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统，由多工位冲孔设备组成自动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统，由多工位冲孔设备组成'
					},
					{
						id: 0,
						xz: false,
						img: require('../assets/anliimg.png'),
						tit: '2座椅护罩冲孔设备',
						text: '22自动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统，由多工位冲孔设备组成自动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统。'
					},
					{
						id: 0,
						xz: false,
						img: require('../assets/anliimg.png'),
						tit: '3座椅护罩冲孔设备',
						text: '33自动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统，由多工位冲孔设备组成'
					},
					{
						id: 0,
						xz: false,
						img: require('../assets/anliimg.png'),
						tit: '4座椅护罩冲孔设备',
						text: '44自动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统，由多工位冲孔设备组成自动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统，由多工位冲孔设备组成自动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统，由多工位冲孔设备组成'
					},
					{
						id: 0,
						xz: false,
						img: require('../assets/anliimg.png'),
						tit: '5座椅护罩冲孔设备',
						text: '55自动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统，由多工位冲孔设备组成'
					},
					{
						id: 0,
						xz: false,
						img: require('../assets/anliimg.png'),
						tit: '6座椅护罩冲孔设备',
						text: '66自动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统，由多工位冲孔设备组成自动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统，由多工位冲孔设备组成自动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统，由多工位冲孔设备组成'
					},
					{
						id: 0,
						xz: false,
						img: require('../assets/anliimg.png'),
						tit: '7座椅护罩冲孔设备',
						text: '77自动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统，由多工位冲孔设备组成'
					},
					{
						id: 0,
						xz: false,
						img: require('../assets/anliimg.png'),
						tit: '8座椅护罩冲孔设备',
						text: '88自动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统，由多工位冲孔设备组成'
					},
					{
						id: 0,
						xz: false,
						img: require('../assets/anliimg.png'),
						tit: '9座椅护罩冲孔设备',
						text: '99自动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统，由多工位冲孔设备组成'
					},
					{
						id: 0,
						xz: false,
						img: require('../assets/anliimg.png'),
						tit: '10座椅护罩冲孔设备',
						text: '100自动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统由多工位冲孔设备组成动座椅冲孔系统，由多工位冲孔设备组成'
					},
				],
				dataItem: {},
				caseFenlei:[],
				dataShow:false,
				minHeight:'0px',
				minheights:'',
			}
		},
		mounted() { //声明周期

			window.pageYOffset = 0;
			document.documentElement.scrollTop = 0;
			document.body.scrollTop = 0
			
			let that = this;
							

			
			
			//获取案例分类
			that.$axios.post('http://www.sy-eray.com/index.php/api/demo/alfl', {
				// 'aa':1
			}).then(function(response) {
				let id;
				let w = document.documentElement.clientWidth;
				// console.log(w)
				if(w<1200){ //手机
					// console.log('手机');
					let item = {
						id: 0,
						name: '全部',
						xz: true
					};
					let caseFenlei = response.data.data;
					caseFenlei.forEach(function(item) {
						item.xz = false
					})
					// caseFenlei[0].xz = true;
					caseFenlei.unshift(item);
					that.caseFenlei = caseFenlei;
					// console.log('案例分类',that.caseFenlei);
					
					//获取案例展示数据
					that.$axios.post('http://www.sy-eray.com/index.php/api/demo/alilist', {
						'id':0
					}).then(function(response) {
						if(response.data.data.length == 0){
							console.log(response.data.data)
							that.dataShow = false;
						}else{
							that.dataArr = response.data.data;
							that.dataArr.forEach(function(item) {
								item.xz = false
							})
							that.dataArr[0].xz = true;
							that.dataItem = that.dataArr[0];
							that.dataShow = true;
						}
					
					
					}).catch(function(error) {
						console.log(error);
					});
					
				}else{ //电脑
					// console.log('电脑')
					
					let caseFenlei = response.data.data;
					
					caseFenlei.forEach(function(item,index) {
						item.xz = false;
						if(item.name == '自动化'){
							let a = item;
							a.xz = true;
							id = item.id;
							caseFenlei.splice(index,1);
							caseFenlei.unshift(a);
						}
					})
					// console.log('caseFenlei',caseFenlei)
					that.caseFenlei = caseFenlei;
					// console.log('案例分类',that.caseFenlei);
					//获取案例展示数据
					that.$axios.post('http://www.sy-eray.com/index.php/api/demo/alilist', {
						'id':id
					}).then(function(response) {
						if(response.data.data.length == 0){
							console.log(response.data.data)
							that.dataShow = false;
						}else{
							that.dataArr = response.data.data;
							that.dataArr.forEach(function(item) {
								item.xz = false
							})
							that.dataArr[0].xz = true;
							that.dataItem = that.dataArr[0];
							that.dataShow = true;
						}
					
					
					}).catch(function(error) {
						console.log(error);
					});
					
				}
				
				//获取移动端分类的高度
				that.minheights = setTimeout(function(){
					that.minHeight = 'calc(100% - ' + that.$refs.elememtFenlei.offsetHeight + 'px - 44px - 30px - 49px)';
					// console.log(that.minHeight);
					that.minheights = ''
				},100);
				
			}).catch(function(error) {
				console.log(error);
			});

		},
		methods: {
			tapItem(index) {
				let that = this;
				that.dataArr.forEach(function(item) {
					item.xz = false;
				})
				that.dataArr[index].xz = true;
				that.dataItem = that.dataArr[index];
			},
			
			
			//点击案例分类
			tapFenleiItem(e){
				let that = this;
				// console.log(e);
				that.caseFenlei.forEach(function(item){
					item.xz = false;
				})
				that.caseFenlei[e].xz = true;
				//获取案例数据
				that.$axios.post('http://www.sy-eray.com/index.php/api/demo/alilist', {
					'id':that.caseFenlei[e].id,
				}).then(function(response) {
					if(response.data.data.length == 0){
						// console.log(response.data.data)
						that.dataShow = false;
					}else{
						that.dataArr = response.data.data;
						that.dataArr.forEach(function(item) {
							item.xz = false
						})
						that.dataArr[0].xz = true;
						that.dataItem = that.dataArr[0];
						that.dataShow = true;
						// console.log(response.data.data)
					}
					
					
				}).catch(function(error) {
					console.log(error);
				});
			},
		}
	}
</script>

<style>
	.caseBox {
		/* background: #fafafa; */
	}

	.caseBox-banner {
		width: 100%;
		height: 480px;
		background-image: url(../assets/chenggonganliBg.jpg);
		background-size: 100% 100%;
	}

	.caseBox-banner-in {
		width: 1200px;
		height: 100%;
		margin: 0 auto;
		position: relative;
	}

	.caseBox-banner-in-logo {
		width: 481px;
		height: 70px;
		background-image: url(../assets/chenggonganlilogo.png);
		background-size: 100% 100%;
		position: absolute;
		top: 250px;
		left: 0;
	}

	.caseBox-nr {
		width: 1200px;
		height: auto;
		margin: 0 auto;
		margin-top: 100px;
		margin-bottom: 80px;
		box-sizing: border-box;
		position: relative;
		/* background: #FFC0CB; */
	}

	.caseBox-nr-left {
		width: 540px;
		height: 100%;
		/* background: tan; */
		float: left;

	}

	.caseBox-nr-left-item {
		width: 250px;
		height: 151px;
		/* background: #009C41; */
		float: left;
		margin-right: 20px;
		margin-bottom: 20px;
		box-sizing: border-box;
		/* padding: 10px; */
		border: 1px solid #eeeeee;
		overflow: hidden;
		position: relative;
	}

	.caseBox-nr-left-item img {
		transition: all .5s;
	}

	.caseBox-nr-left-item:hover {
		border: 2px solid #fed24f;
	}

	.caseBox-nr-left-item:hover img {
		transform: scale(1.2);
	}

	.xz {
		border: 3px solid #fed24f;
	}

	.caseBox-nr-right {
		width: 660px;
		height: 100%;
		border: 1px solid #eeeeee;

		background: #ffffff;
		float: left;
		overflow: auto;
		box-sizing: border-box;
		padding: 30px 20px 0 20px;
	}


	.caseBox-nr-left-item-tit {
		width: 100%;
		height: 40px;
		background: rgba(0, 0, 0, .4);
		text-align: center;
		font-size: 14px;
		color: #ffffff;
		position: absolute;
		left: 0;
		bottom: 0;
		line-height: 40px;
	}

	.caseBox-nr-fy {
		width: 540px;
		height: 40px;
		/* background: red; */
		position: absolute;
		bottom: -40px;
		left: 0;
		padding: 0 150px;
		box-sizing: border-box;
	}

	.caseBox-nr-fy-item {
		width: 100px;
		height: 100%;
		/* background: pink; */
		float: left;
		margin-right: 20px;
		box-sizing: border-box;
		text-align: center;
		line-height: 40px;
		font-size: 14px;
		color: #888888;
	}

	.caseBox-nr-fy-item:hover {
		border: 1px solid #e1e1e1;
		box-sizing: border-box;
	}

	.caseBox-nr-right-tit {
		width: 100%;
		font-size: 24px;
		color: #353535;
		padding-bottom: 40px;
		box-sizing: border-box;
		text-align: center;
	}

	.caseBox-nr-right-img {
		width: 100%;
		height: auto;
		/* background: pink; */
		font-size: 0;
		padding-bottom: 50px;
		box-sizing: border-box;
	}

	.caseBox-nr-right-text {
		width: 100%;
		font-size: 16px;
		line-height: 28px;
		color: #666666;
		padding-bottom: 50px;
		box-sizing: border-box;
	}

	.caseBox-nr-fenlei {
		width: 100%;
		height: auto;
		/* background: red; */
		margin-bottom: 50px;
		box-sizing: border-box;
		color: #c6c7c7;
	}
	.caseBox-nr-fenlei-item{
		width: 120px;
		height: 100%;
		margin-right: 30px;
		box-sizing: border-box;
		border-radius: 30px;
		font-size: 16px;
		line-height: 50px;
		text-align: center;
		border: 1px solid #ededed;
		cursor: pointer;
		display: inline-block;
		margin-bottom: 20px;
		color: #a9a9a9;
	}
	.caseBox-nr-fenlei-item-xz{
		background: #52dedb;
		border: 1px solid #ededed;
		font-weight: bold;
		color: #ffffff;
	}
	.caseBox-nr-fenlei-item:hover{
		background: #52dedb;
		border: 1px solid #ededed;
		font-weight: bold;
		color: #ffffff;
	}
	.min-caseBox {
		display: none;
	}
	@media only screen and (max-width: 1200px) {
		.caseBox{
			width: 100%;
			height: 100%;
		}
		.max-caseBox {
			display: none;
		}
		.min-caseBox {
			display: block;
			background: #ffffff;
			width: 100%;
			height: 100%;
		}
		.min-caseBox-top{
			width: 100%;
			height: 2.75rem;
			background: #f8f8f8;
			border-bottom: 0.0625rem solid #ededed;
			box-sizing: border-box;
			position: relative;
			text-align: center;
			font-size: 1.125rem;
			color: #353535;
			line-height: 2.75rem;
		}
		.min-caseBox-top-icon{
			width: 2.75rem;
			height: 2.75rem;
			/* background: tan; */
			padding: 0.5rem;
			box-sizing: border-box;
			background-image: url(../assets/minfanhuijian.png);
			background-size: 80% 80%;
			position: absolute;
			left: 0;
			top: 0.25rem;
		}
		.min-home-case-fenlei {
			width: 100%;
			height: auto;
			/* background: red; */
			padding: 0 0.9375rem;
			box-sizing: border-box;
			margin-bottom: 0.625rem;
			margin-top: 1.25rem;
		}
		
		.min-home-case-fenlei-item {
			/* width: calc(100% / 4 - 10px); */
			width: auto;
			height: 2rem;
			padding: 0 0.625rem;
			text-align: center;
			border: 1px solid #ededed;
			line-height: 2rem;
			font-size: 0.875rem;
			color: #ffffff;
			box-sizing: border-box;
			display: inline-block;
			vertical-align: top;
			margin-bottom: 0.625rem;
			margin-right: 0.625rem;
			border-radius: 0.3125rem;
			color: #a9a9a9;
		}
		
		.min-home-case-fenlei-item-xz {
			background: #52dedb;
			color: #ffffff;
			border: 1px solid #52dedb;
		}
		.min-caseBox-box{
			width: 100%;
			/* height: calc(100% - 116px); */
			/* background: pink; */
		}
		.min-caseBox-box-left{
			width: 7.5rem;
			height: 100%;
			background: #ffffff;
			float: left;
			padding: 0.625rem;
			padding-top: 0;
			padding-right: 0;
			box-sizing: border-box;
		}
		.min-caseBox-box-left-in{
			width: 100%;
			height: 100%;
			/* border: 1px solid #ededed; */
			box-sizing: border-box;
			/* padding-left: 0.5rem; */
			/* padding-bottom: 0.625rem; */
			overflow-y: auto;
		}
		.min-caseBox-box-right{
			width: calc(100% - 7.5rem);
			height: 100%;
			/* background: pink; */
			float: left;
			padding: 0.625rem;
			padding-top: 0;
			box-sizing: border-box;
			/* border: 1px solid #ededed; */
			overflow-y: auto;
		}
		.min-caseBox-box-right-in{
			width: 100%;
			height: 100%;
			box-sizing: border-box;
			padding: 0.5rem;
			padding-top: 0;
		}
		.min-caseBox-box-left-in-item{
			width: 100%;
			height: auto;
			background: #f8f8f8;
			margin-bottom: 0.625rem;
			box-sizing: border-box;
		}
		.min-caseBox-box-left-in-item-xz{
			border: 1px solid #fed24f;
			box-sizing: border-box;
			padding: 0.3125rem;
		}
		.min-caseBox-box-right-in-tit{
			width: 100%;
			height: auto;
			font-size: 1rem;
			margin-bottom: 0.9375rem;
			/* margin-top: 0.9375rem; */
			box-sizing: border-box;
		}
		.min-caseBox-box-right-in-img{
			width: 100%;
			height: auto;
			/* background: pink; */
			font-size: 0;
			padding-bottom: 0.9375rem;
			box-sizing: border-box;
		}
		.min-caseBox-box-right-in-text{
			width: 100%;
			font-size: 0.875rem;
			line-height: 28px;
			color: #666666;
			padding-bottom: 0.9375rem;
			box-sizing: border-box;
		}
	}
</style>
